import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Components
import SendButton from "../../../components/pushNotifications/sendButton";
import SendTestButton from "../../../components/pushNotifications/sendTestButton";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as pushNotificationsActions from "../../../redux/actions/pushNotifications";
// Styles
import "./view.css";

const PushNotificationsView = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);
  const user = useSelector(state => state.authReducer.user);
  const reducerName = "pushNotificationsReducer";
  const selectedRows = useSelector((state) => state[reducerName].selectedRows);

  // Set consts and vars
  const page = "push_notifications";
  const itemNameSingular = "Notificació push";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [
    `title`,
    `body`,
    `date`,
    `time`,
    `action`,
    `action_reference_id`,
    `enabled`,    
    `sent`,
  ];
  const sorters = filters;
  const columns = [
    { 
      name: "files_1",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "title",
      width: `250px`,
      header: {
        dataType: "string",
        placeholder: "Títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "body",
      header: {
        dataType: "string",
        placeholder: "Descripció",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    // { 
    //   name: "date",
    //   width: `150px`,
    //   header: {
    //     dataType: "date",
    //     placeholder: "Data",
    //     textAlign: "center",
    //   },
    //   style: {
    //     textAlign: "center",
    //     overflow: "hidden",         // Oculta el contenido que sobresale
    //     textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
    //     whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
    //   }
    // },
    // { 
    //   name: "time",
    //   width: `150px`,
    //   header: {
    //     dataType: "string",
    //     placeholder: "Hora llançament",
    //     textAlign: "center",
    //   },
    //   style: {
    //     textAlign: "center",
    //     overflow: "hidden",         // Oculta el contenido que sobresale
    //     textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
    //     whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
    //   }
    // },
    { 
      name: "action",
      width: `150px`,
      header: {
        dataType: "string",
        placeholder: "Acció",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "action_reference_id",
      width: `100px`,
      header: {
        dataType: "string",
        placeholder: "Id ref.",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    // { 
    //   name: "enabled",
    //   width: `105px`,
    //   header: {
    //     dataType: "boolean",
    //     placeholder: "Habilitat",
    //     textAlign: "center",
    //   },
    //   style: {
    //     textAlign: "center",
    //     overflow: "hidden",         // Oculta el contenido que sobresale
    //     textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
    //     whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
    //   }
    // },
    { 
      name: "sent",
      width: `105px`,
      header: {
        dataType: "boolean",
        placeholder: "Enviada",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="push-notifications-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"title"}
          menuConfig={{
            buttonNew: { visible: !!user && user.grants.push_notifications },
            buttonEdit: { visible: !!user && user.grants.push_notifications },
            buttonDelete: { visible: !!user && user.grants.push_notifications },
            nextChildren: [
              <>
                <div style={{ flex: 1 }}></div>
                <SendTestButton 
                  id={selectedRows.length > 0 ? selectedRows[0]['id'] : 0}
                  setIsLoading={setIsLoading}
                  disabled={selectedRows.length === 0 || selectedRows[0]['sent']}
                />
                <div style={{ width: "10px" }}></div>
                <SendButton 
                  id={selectedRows.length > 0 ? selectedRows[0]['id'] : 0}
                  setIsLoading={setIsLoading}
                  disabled={selectedRows.length === 0 || selectedRows[0]['sent']}
                  onSend={() => {
                    dispatch(pushNotificationsActions.setSelectedRows([]));
                    setRefreshData(true);
                  }}
                />
              </>,
            ],            
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Programació de <b>NOTIFICACIONS PUSH</b>",
          }}
          reducerName={reducerName}
          itemNameSingular={itemNameSingular}
          itemIsMale={false}
          actions={pushNotificationsActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"push_notifications"}
        />
      </div>
    </MainLayout>
  );
};

export default PushNotificationsView;
